<template>
    <div>
        <message-controller></message-controller>
        <navbar></navbar>
        <div class="container pt-4">
            <h1 class="title">
                Děti
                <b-icon class="clickable" icon="plus-square-fill" variant="info"
                        @click="addNewItem()"></b-icon>

            </h1>

            <table class="table">
                <tbody>
                <tr v-for="item in posts.records" v-bind:key="item.id" v-bind:class="{ 'unavailable': item.available !== 1 }">
                    <td>
                        <h3 class="item-wrap clickable" >
                            <div @click="openModal(item.id)">{{item.firstname}} {{item.surname}}</div>
                            <div>
                                {{item.quantity}}
                                <b-icon class="clickable" icon="pencil-square" variant="info"
                                        @click="openModalEdit(item.id)"></b-icon>
                            </div>
                        </h3>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <b-modal id="modal-students-edit" class="modal" hide-header >
            <div v-if="modalData" class="d-block">
                <b-form-group>
                    <label>Jméno</label>
                    <b-form-input
                        v-model="modalData.firstname"
                        type="text"
                        placeholder=""
                        @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>

                <b-form-group>
                    <label>Příjmení</label>
                    <b-form-input
                            v-model="modalData.surname"
                            type="text"
                            placeholder=""
                            @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>

                <b-form-group>
                    <label>Email</label>
                    <b-form-input
                            v-model="modalData.email"
                            type="email"
                            placeholder=""
                            @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>
    
                <b-form-group>
                    <label>Telefon</label>
                    <b-form-input
                        v-model="modalData.tel"
                        type="text"
                        placeholder=""
                        @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>
    
                <b-form-group>
                    <label>Narozen</label>
                    <b-form-input
                        v-model="modalData.birthday"
                        type="date"
                        placeholder=""
                        @blur="updateModalData()"
                    ></b-form-input>
                </b-form-group>
                
                <b-form-group>
                    <label>Rodné číslo</label>
                    <b-form-input
                        v-model="modalData.national_id_number"
                        type="text"
                        placeholder=""
                        @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>
                <hr>
                <b-form-group>
                    <label>Rodič</label>
                    <b-form-input
                        v-model="modalData.parent"
                        type="text"
                        placeholder=""
                        @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>
                
                <b-form-group>
                    <label>Email <small>(Rodiče)</small></label>
                    <b-form-input
                            v-model="modalData.email2"
                            type="email"
                            placeholder=""
                            @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>
    
                <b-form-group>
                    <label>Telefon</label>
                    <b-form-input
                        v-model="modalData.tel_parent"
                        type="text"
                        placeholder=""
                        @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>
                
                <b-form-group >
                    <label>Akce</label>
                    <b-form-checkbox-group
                            class="students-group"
                            v-model="modalData.courses"
                            name="coursesSelected"
                            value-field="id"
                            text-field="name"
                            :options="courses.records"
                            stacked
                            size="lg"
                            @change="updateModalData()">
                    </b-form-checkbox-group>

                </b-form-group>


                <b-form-group class="text-left mt-5">
                    <b-button variant="danger" size="sm"  @click="deleteItem(modalData.id)">Smazat
                        <b-icon icon="trash-fill" ></b-icon>
                    </b-button>
                </b-form-group>
            </div>

            <template v-slot:modal-footer="">
                <b-button block @click="$bvModal.hide('modal-students-edit')">Zavřít</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

    import axios from 'axios'
    import Navbar from "../components/navbar";
    import MessageController from "../components/message-controller";

    export default {
        name: "students",
        components: {MessageController, Navbar},
        data() {
            return {
                posts: [],
                courses: [],
                modalData: Object,
                errors: [],
                changedModalId: null,
                newCommentLog: ''
            }
        },
        methods: {

            async loadData() {
                try {
                    const response_data = await axios({
                        url: process.env.VUE_APP_SERVER+'students/list.php',
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded',
                        },
                        method: 'GET'
                    });

                    this.posts = response_data.data;

                    if (this.changedModalId) {
                        this.changeDataInModal(this.changedModalId);
                    }


                } catch (error) {
                    console.log("error", error);
                    this.$store.dispatch('logout');
                }
            },

            async loadCoursesData() {
                try {
                    const response_data = await axios({
                        url: process.env.VUE_APP_SERVER+'courses/list.php',
                        headers: { 'content-type': 'application/x-www-form-urlencoded' },
                        method: 'GET'
                    });

                    this.courses = response_data.data;


                } catch (error) {
                    console.log("error", error);
                    this.$eventHub.$emit('openMessageController', 'error', 'Nelze načíst labely');
                }

            },

            async updateModalData() {
                try {
                    await axios({
                        url: process.env.VUE_APP_SERVER+'students/update-item.php',
                        headers: { 'content-type': 'application/x-www-form-urlencoded' },
                        data: this.modalData,
                        method: 'PUT'
                    });
                    this.loadData();
                    this.$eventHub.$emit('openMessageController', 'success', 'Změna proběhla úspěšně');

                } catch (error) {
                    this.loadData();
                    console.log("error", error);
                    this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
                }

            },

            async deleteItem(id) {
                try {
                    if (confirm("Opravdu smazat?")) {
                        await axios({
                            url: process.env.VUE_APP_SERVER + 'students/delete-item.php',
                            headers: {'content-type': 'application/x-www-form-urlencoded'},
                            data: {'id': id},
                            method: 'DELETE'
                        });

                        this.$bvModal.hide('modal-students-edit');
                        const index = this.posts.records.findIndex(posts => posts.id === id);
                        this.posts.records.splice(index, 1);


                        this.loadData();
                        this.$eventHub.$emit('openMessageController', 'success', 'Položka byla smazána');
                    }

                } catch (error) {
                    this.loadData();
                    console.log("error", error);
                    this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
                }

            },

            async addNewItem() {

                try {
                    const response = await axios({
                        url: process.env.VUE_APP_SERVER+'students/new-item.php',
                        headers: { 'content-type': 'application/x-www-form-urlencoded' },
                        method: 'POST'
                    });

                    // data se načítají ve špatnou chvíli.
                    this.loadData();
                    this.openModalEdit(response.data.id, true);
                    this.$eventHub.$emit('openMessageController', 'success', 'Položka byla přidána');

                } catch (error) {
                    this.loadData();
                    console.log("error", error);
                }

            },

            openModal(itemId) {
                this.changedModalId = itemId;
                this.changeDataInModal(itemId);
                this.$bvModal.show('modal-students'); // open bs modal



            },
            openModalEdit(itemId) {
                this.changedModalId = itemId;
                this.changeDataInModal(itemId);
                this.$bvModal.show('modal-students-edit'); // open bs modal



            },
            changeDataInModal(itemId) {
                try {
                    this.modalData = this.posts.records.find( ({ id }) => id === itemId );
                } catch(err) {
                    console.log(err);
                }

            },
        },
        computed : {
            isEditable : function () { return (this.$route.params.action === 'edit' && this.$store.getters.isAdmin) }
        },
        created() {
            this.loadData();
            this.loadCoursesData();
        }
    }
</script>

<style scoped lang="scss">
    .table {
        max-width: 100%;
        th, td {
            padding-left: 0;
            padding-right: 0;
        }
    }

    h3.item-wrap {
        color: var(--cyan);
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

    }
    .description {
        color: #6c757d;
        line-height: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;

    }

    .icons {
        font-size: 1.5rem;
        float: right;
        cursor: pointer;
    }

    .badge {
        letter-spacing: .5px;
        font-weight: 500;
        vertical-align: middle;
    }


    .card-body {
        overflow: auto;
        max-height: 300px;
    }


    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .history_list {
        padding: 0;
        margin: 0;
        td {
            color: var(--gray);
            vertical-align: top;
            display: flex;
            flex-direction: column;
        }

        .table-date {
            white-space: nowrap;
        }

        &__row {
             width: 100%;
             flex: 1 0 100%;
             display: flex;
             justify-content: space-between;
         }
    }
</style>
